import FeatureEnabledDashboard from 'portal/src/layouts/base/FeatureEnabledDashboard';

import isEvChargingViewEnabled from './isEvChargingViewEnabled';

export default function EvChargingView({
  slug,
  disabledSlug,
}: {
  slug: string;
  disabledSlug?: string;
}): React.ReactElement {
  return (
    <FeatureEnabledDashboard
      slug={slug}
      disabledSlug={disabledSlug}
      isFeatureEnabled={isEvChargingViewEnabled}
    />
  );
}
